// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__ugLJz","heroCarousel":"Hero_heroCarousel__2t5Wo"};